(function () {
  'use strict';

  function initToggle(section) {
    var sectionId = section.getAttribute('data-section-id');
    var toggle = document.getElementById('itg-toggle-' + sectionId);
    var img1 = section.querySelector('.itg-hero__img--1');
    var img2 = section.querySelector('.itg-hero__img--2');

    if (!toggle || !img1 || !img2) return;

    toggle.addEventListener('click', function () {
      var isChecked = toggle.getAttribute('aria-checked') === 'true';
      var next = !isChecked;

      toggle.setAttribute('aria-checked', String(next));

      if (next) {
        img2.classList.add('is-active');
        img1.classList.remove('is-active');
      } else {
        img1.classList.add('is-active');
        img2.classList.remove('is-active');
      }
    });

    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        toggle.setAttribute('aria-checked', 'false');
        img1.classList.add('is-active');
        img2.classList.remove('is-active');
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        toggle.setAttribute('aria-checked', 'true');
        img2.classList.add('is-active');
        img1.classList.remove('is-active');
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.itg-hero');
    sections.forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.itg-hero');
    if (section) initToggle(section);
  });
})();
